export default __webpack_public_path__ + "assets/barometer.8b6e33cb.svg";